import { PdpBuyActions } from './PdpBuyActions';

interface BuyNowBarProps {
  discountedPrice: number | null;
  gmsFirstInstallmentDiscountEnabled: boolean;
  gmsFirstInstallmentDiscountPercentage: number;
  onBuyNow?: () => void;
  onBuyNowClick?: () => void;
  onGmsPlanOpen?: (monthlyAmount: number) => void;
  onGmsSubscribeClick?: () => void;
  onGmsTncClick?: () => void;
}

export function BuyNowBar(props: BuyNowBarProps) {
  return <PdpBuyActions variant="fixed" {...props} />;
}
